import Scrollbar from 'smooth-scrollbar';
class AvSmoothScroll {
    constructor() {

    }
}

export default AvSmoothScroll;
